import axiosInstance from '../axiosInstance';
import { getManagerRoutePath } from '../managerRouteUtil';

/**
 * Staff Reports — non-resident operational issues raised by staff from the
 * mobile app. Resident-related events go through Incidents instead.
 */
const staffReportsService = {
  // Filters are passed straight through; the API treats 'all' as no filter.
  list: async ({ search, status, priority, category } = {}) => {
    const routePath = getManagerRoutePath();
    const params = {};
    if (search) params.search = search;
    if (status && status !== 'all') params.status = status;
    if (priority && priority !== 'all') params.priority = priority;
    if (category && category !== 'all') params.category = category;
    const response = await axiosInstance.get(`/${routePath}/staff-reports`, { params });
    return response.data;
  },

  getOne: async (id) => {
    const routePath = getManagerRoutePath();
    const response = await axiosInstance.get(`/${routePath}/staff-reports/${id}`);
    return response.data;
  },

  // Partial update — send only what changed (status / assigned_to / priority).
  update: async (id, payload) => {
    const routePath = getManagerRoutePath();
    const response = await axiosInstance.patch(`/${routePath}/staff-reports/${id}`, payload);
    return response.data;
  },

  // visible: false records a manager-only internal note.
  addUpdate: async (id, { message, visible = true }) => {
    const routePath = getManagerRoutePath();
    const response = await axiosInstance.post(`/${routePath}/staff-reports/${id}/updates`, {
      message,
      visible,
    });
    return response.data;
  },

  removeUpdate: async (id, updateId) => {
    const routePath = getManagerRoutePath();
    const response = await axiosInstance.delete(
      `/${routePath}/staff-reports/${id}/updates/${updateId}`
    );
    return response.data;
  },

  createAnnouncement: async (id, { body, audience_type = 'all', audience_roles } = {}) => {
    const routePath = getManagerRoutePath();
    const response = await axiosInstance.post(`/${routePath}/staff-reports/${id}/announcement`, {
      body,
      audience_type,
      audience_roles,
    });
    return response.data;
  },
};

export default staffReportsService;
